<template>
  <div class="flex space-x-4">
    <img
      class="h-14 rounded-full"
      :src="avatar()"
      alt="avatar"
    >
    <div>
      <div
        v-if="customer.information.name"
        class="text-xl flex flex-row items-center gap-2 py-1"
        :class="active ? 'font-semibold': ''"
      >
        <div>{{ customer.information.name }}</div>
        <span v-if="smokingLabel" :title="smokingLabel">
          <icon
            name="mdi-smoking"
            :size="18"
            :color="active ? '#FFFFFF' : '#000000'"
          />
        </span>
      </div>
      <div class="flex flex-col sm:flex-row sm:flex-wrap sm:mt-0 sm:space-x-6">
        <div v-if="customer.information.birth_date">
          <div class="text-sm">
            né le {{ customer.information.formatted_birth_date }}
          </div>
          <div class="text-sm">
            {{ age }}
          </div>
        </div>
        <div
          v-else
          class="text-sm"
        >
          Date de naissance non renseignée.
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import userMaleIcon from '@/assets/icons/user-male.png';
import userFemaleIcon from '@/assets/icons/user-female.png';
import dateHelper from "@/core/helpers/dateHelper";
import Icon from "@/core/components/icon/Icon.vue";
import {SmokingStatus} from "@/customer/interfaces/DeclaredInformation";

export default defineComponent({
    name: 'CustomerSummary',
    components: {Icon},
    props: {
        customer: {
            type: Object,
            required: true
        },
        active: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            userMaleIcon,
            userFemaleIcon
        };
    },

    computed: {
        age() {
            if(!this.customer.information.birth_date) {
                return 'Âge non renseigné';
            }

            return dateHelper.age(this.customer.information.birth_date);
        },
        smokingLabel(): string | null {
            switch (this.customer.declared_information?.smoking) {
                case SmokingStatus.SMOKER:
                    return 'Fumeur';
                case SmokingStatus.OCCASIONAL_SMOKER:
                    return 'Fumeur occasionnel';
                default:
                    return null;
            }
        }
    },
    methods: {
        avatar() {
            return this.customer.information.gender === 1
                ? this.userMaleIcon
                : this.userFemaleIcon;
        }
    }
});
</script>
